import React, { useState, useEffect,useRef } from 'react';
import { Box, Typography, TextField, Button, IconButton } from '@mui/material';
import { Carousel } from 'react-bootstrap'; 
import axios from 'axios';
import ReactQuill from 'react-quill';
import CloseIcon from '@mui/icons-material/Close';
const NewsManagement = () => {
  const [newsList, setNewsList] = useState([]);
  const [headline, setHeadline] = useState('');
  const [summary, setSummary] = useState('');
  const token = localStorage.getItem('token');
  const [files, setFiles] = useState([]); // ✅ for multiple images
   // ✅ file input ref
  const fileInputRef = useRef(null);

  const fetchNews = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/news`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setNewsList(res.data))
      .catch((err) => console.error('Fetch news error:', err));
  };

  useEffect(() => {
    fetchNews();
  }, []);
  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const addNews = () => {
    if (!headline || !summary) return;
    const formData = new FormData();
    formData.append('headline', headline);
    formData.append('summary', summary);
    files.forEach((file) => formData.append('images', file));

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/news`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
      )
      .then(() => {
        setHeadline('');
        setSummary('');
        setFiles([]);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        fetchNews();
      })
      .catch((err) => console.error('Add news error:', err));
  };

  const deleteNews = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/news/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => fetchNews())
      .catch((err) => console.error('Delete news error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>News</Typography>
      <TextField
        label="Headline"
        value={headline}
        onChange={(e) => setHeadline(e.target.value)}
        fullWidth
        margin="dense"
      />
      <ReactQuill
          id="job-description"
          theme="snow"
          value={summary}
          onChange={content =>
            setSummary(content)
          }
          style={{
            height: 144, // ~6 rows
            overflowY: 'auto',
            borderRadius: 4,
            border: '1px solid rgba(0, 0, 0, 0.23)', // MUI-like border
            boxSizing: 'border-box',
            marginBottom: 16, // Like sx={{ mb: 2 }}
          }}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
      />
      {/* File input for multiple images */}
      <input
        type="file"
        ref={fileInputRef}
        multiple
        onChange={(e) => setFiles(Array.from(e.target.files))}
        style={{ marginBottom: 12 }}
      />

    {/* Preview selected images */}
      {files.length > 0 && (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
          {files.map((file, index) => (
            <Box key={index} sx={{ position: 'relative' }}>
              <img
                src={URL.createObjectURL(file)}
                alt={`preview-${index}`}
                style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
              />
              <IconButton
                size="small"
                onClick={() => removeFile(index)}
                sx={{
                  position: 'absolute',
                  top: -8,
                  right: -8,
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  '&:hover': { backgroundColor: 'red' },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}  
        </Box>
      )}

      <Button onClick={addNews} variant="contained" sx={{ mt: 1 }}>Add News</Button>

      <ul style={{ marginTop: '1rem' }}>
        {newsList.map((item) => (
          <li key={item.id}>
            <strong>{item.headline}</strong> (By {item.created_by} on {new Date(item.createdDate).toLocaleDateString()})<br />
            <div dangerouslySetInnerHTML={{ __html: item.summary }} />
            {item.images && item.images.length > 0 && (
              <Carousel variant="dark" interval={3000} indicators={false} style={{ width: 300 }}>
                {item.images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={img.base64} // directly use base64 string
                      alt={`news-${idx}`}
                      style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 4 }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
            <Button
              variant="text"
              color="error"
              size="small"
              onClick={() => deleteNews(item.id)}
              sx={{ ml: 1 }}
            >
              Delete
            </Button>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default NewsManagement;
